import { ComboboxData } from 'ui';

/**
 * Gets the key from combobox data
 * priority is given to string items, then group name, then value, then label
 *
 */
const getKeyFromData = (item: ComboboxData[number]): string | null => {
  if (typeof item === 'string') return item;
  if (typeof item === 'object' && 'group' in item) return item.group;
  if (typeof item === 'object' && 'value' in item && item.value) return item.value;

  return item.label ? item.label : null;
};

export { getKeyFromData };
